import { useCallback } from 'react';

import type { ConnectorSource } from '../../../common/constants/schemas/3p-config';
import { useAnalytics, useCommonAndPrivateAttributes } from '../../analytics';

interface Fire3pLinkInteractedProps {
	metadata: {
		product?: string;
		is3PSmartLink?: boolean;
		connectorSource?: ConnectorSource | undefined;
	};
	position?: number;
	rightOrLeftClick: 'left' | 'right';
	experienceName: 'search-page' | 'quick-find';
}

/**
 * @returns a callback to fire an event when the 3p result
 * is clicked by the user on search page or quick find
 */
export const useThirdPartyLinkInteracted = () => {
	const { fireAnalyticsEvent } = useAnalytics();
	const { commonAttributes, nonPrivacySafeAttributes } = useCommonAndPrivateAttributes();

	return useCallback(
		({ metadata, position, experienceName, rightOrLeftClick }: Fire3pLinkInteractedProps) => {
			fireAnalyticsEvent({
				eventType: 'ui',
				action: 'clicked',
				actionSubject: 'thirdPartyLink',
				attributes: {
					commonAttributes,
					additionalAttributes: {
						position,
						experienceName,
						linkProduct: metadata.product,
						connectorId: metadata.connectorSource,
						rightOrLeftClick,
						isSmartLink: metadata.is3PSmartLink,
					},
				},
				nonPrivacySafeAttributes,
			});
		},
		[fireAnalyticsEvent, commonAttributes, nonPrivacySafeAttributes],
	);
};
